<template>
  <section class="brandStory_main">
    <div class="container in_wrap">
      <div class="bsTit">
        <p class="msg">
          우리 몸 속 더 깊은 이야기
        </p>
        <p class="msg2">
          딥톡 플러스<span class="mbr"></span>(DEEP TALK PLUS)
        </p>
      </div>
      <div class="row different">
        <div class="col-sm-6 order-2 order-sm-1">
          <a href="" class="go" @click.prevent="$router.push('/brandstory')">자세히보기</a>
        </div>
        <div class="col-sm-6 order-1 order-sm-2">
          <div class="logo_wrap">
            <img
              src="@/assets/images/common/logo_white.svg"
              class="logo"
              alt="Lifening"
            />
          </div>
          <div class="txt">
            <div class="bsCon bium">
              #비움
            </div>
            <div class="bsCon cheum">
              #채움
            </div>
            <div class="bsCon malgum">
              #맑음
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BrandStory',
};
</script>

<style></style>
